import { render, staticRenderFns } from "./TwAddLc.vue?vue&type=template&id=7445042a&"
import script from "./TwAddLc.vue?vue&type=script&lang=js&"
export * from "./TwAddLc.vue?vue&type=script&lang=js&"
import style0 from "./TwAddLc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports